import { SCol, SRow } from '@avalara/skylab-sdk/react';
import { Fragment, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

import Resources from '../../shared/resources';
import ThankYouBanner from './banner';
import InformationYouNeed from './information-you-need';

import { content, emailLinkText } from '../constants';

const SetUp = styled.h2`
  max-width: 760px;
`;

const ThankYouSContainerFlex = createGlobalStyle`
  s-container {
    all: unset;
    display: flex;
  }
`;

const ThankYou = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <ThankYouSContainerFlex />
      <ThankYouBanner />
      <main className='flex justify-content-center text-center align-items-center'>
        <SRow>
          <SCol span='12' className='pad-top-lg pad-bottom-lg'>
            <SetUp>{emailLinkText}</SetUp>
          </SCol>
        </SRow>
      </main>
      <InformationYouNeed />
      <Resources content={content} />
    </Fragment>
  );
};

export default ThankYou;
